var {
    ImageViewer
} = require("iv-viewer");

var commonFeature = require("./commonFeature");

var $window = $(window);
var $body = $("body");
var isZoomDisabled = false;

function init($slider) {
    if (!$slider || $slider.length === 0) {
        return;
    }

    var thumbs;
    var $sliderThumbs = $slider.closest(".primary-images").find(".anchor-menu-thumbs");
    if ($sliderThumbs.length) {
        thumbs = $sliderThumbs.find(".thumb-image img").clone();
    }

    $slider.addClass("zoom-initiator-slider").on("click", ".slick-slide", function () {
        var $clickedSlide = $(this);
        // Do not open zoom modal if the clicked slide is the 360 customizer view
        if ($clickedSlide.find(".slide-inside--customizer").length > 0) {
            return;
        }
        var indexOfClickedSlide = $clickedSlide.attr("data-slick-index");
        zoomModal.initZoomModal($slider.find(".product-slider-image"), thumbs, indexOfClickedSlide); /* eslint-disable-line */
    });

    $(document).on("click", ".button-open-zoom-in, .link-open-zoom-in", function (e) {
        e.preventDefault();
        var $currentSlide = $slider.find(".slick-current");
        var indexOfClickedSlide = $currentSlide.attr("data-slick-index");
        // Resets slide index if selected slide is the 360 preview
        if ($currentSlide.find(".slide-inside--customizer").length > 0) {
            indexOfClickedSlide = "0";
        }
        zoomModal.initZoomModal($slider.find(".product-slider-image"), thumbs, indexOfClickedSlide); /* eslint-disable-line */
    });
}

function initZoomModal($zoomSources, thumbs, startIndex) {
    if (!$zoomSources || $zoomSources.length == 0) {
        return;
    }
    $(document).off("dblclick", ".zoom-container");
    $(document).off("click", ".button-zoom-in");
    $(document).off("click", ".button-zoom-out");
    $("#zoom-modal").remove();
    var $buttonZoomInToggle = $(".button-open-zoom-in");
    var zoomInLabel = $buttonZoomInToggle.data("zoom-in-label");
    var zoomOutLabel = $buttonZoomInToggle.data("zoom-out-label");
    var doubleTapLabel = $buttonZoomInToggle.data("double-tap-label");
    var modalCloseLabel = $buttonZoomInToggle.data("modal-close-label");

    var htmlString = "<!-- Modal -->" +
        "<div class=\"modal fade\" id=\"zoom-modal\" role=\"dialog\">" +
        "<div class=\"modal-dialog\">" +
        "<!-- Modal content-->" +
        "<div class=\"modal-content\">" +
        `<button type="button" class="button-primary-light button-zoom-in">${zoomInLabel}</button>` +
        `<button type="button" class="button-primary-light button-zoom-out d-none">${zoomOutLabel}</button>` +
        `<button type="button" class="close" data-dismiss="modal" aria-label="${modalCloseLabel}">&nbsp;</button>` +
        "<div class=\"modal-body\">" +
        "<div class=\"slick-slider\" id=\"zoom-slider\">" +
        "</div>" +
        `<div class="text-b2-global text-right d-md-none">${doubleTapLabel}` +
        "</div>" +
        "</div>" +
        `<div class="modal-footer ${!thumbs ? " d-none" : ""}">` +
        "<div class=\"slick-slider\" id=\"zoom-thumb-slider\">" +
        "</div>" +
        "</div>" +
        "</div>" +
        "</div>" +
        "</div>";

    $body.append(htmlString);

    var $zoomSlider = $("#zoom-slider");
    var $zoomThumbSlider = $("#zoom-thumb-slider");

    $zoomSlider.addClass("not-initialized");
    $zoomThumbSlider.addClass("not-initialized");
    $zoomSources.each(function () {
        var $this = $(this);
        var $zoomContainer;

        var src = $this.attr("src");
        var highResSrc = $this.attr("data-high-res-src") || src;
        var srcset = $this.attr("srcset");
        var sizes = $this.attr("data-modal-sizes");
        var data = {
            "src": src,
            "highResSrc": highResSrc,
            "srcset": srcset,
            "sizes": sizes
        };
        $zoomContainer = $("<div/>", {
            "class": "position-relative overflow-hidden zoom-container"
        }).data(data);
        $zoomContainer.appendTo($zoomSlider).wrap("<div/>");

        if (isZoomDisabled) {
            var $img = $("<img/>", {
                "class": "absolute-center",
                "src": highResSrc
            });
            $zoomContainer.html($img);
        }
    });

    if (thumbs) {
        thumbs.each(function () {
            var $this = $(this).clone();
            $this.attr("sizes", $this.data("modal-sizes"));
            var $thumbsContainer = $("<div/>", {
                "class": "thumbs-container"
            });
            $thumbsContainer.appendTo($zoomThumbSlider).wrap("<div/>");
            $thumbsContainer.html($this);
        });
    }

    $("#zoom-modal").on("shown.bs.modal", function () {
        var $anchorMenuThumbs = $zoomSources.closest(".primary-images").find(".anchor-menu-thumbs");
        if ($anchorMenuThumbs) {
            var currentThumbs = $anchorMenuThumbs.find(".thumb-image img").clone();
            if (currentThumbs.length !== thumbs.length) {
                $zoomThumbSlider.empty();
                currentThumbs.each(function () {
                    var $this = $(this);
                    var $thumbsContainer = $("<div/>", {
                        "class": "thumbs-container"
                    });
                    $thumbsContainer.appendTo($zoomThumbSlider).wrap("<div/>");
                    $thumbsContainer.html($this);
                });
            }
        }

        zoomModal.initZoomCarousel(startIndex); /* eslint-disable-line */
    }).modal("show");

    $window.on("windowresize:width", function () {
        $("#zoom-modal").modal("hide");
    });
}

function initZoomCarousel(startIndex) {
    startIndex = parseInt(startIndex, 10) || 0; /* eslint-disable-line */
    var $zoomSlider = $("#zoom-slider");
    var $zoomThumbSlider = $("#zoom-thumb-slider");
    var $zoomOutBtn = $(".button-zoom-out");
    var $zoomInBtn = $(".button-zoom-in");

    if (!isZoomDisabled) {
        $zoomSlider.on("beforeChange", function (_event, slick) {
            var $zoomContainer = $(slick.$slides[slick.currentSlide]).find(".zoom-container");
            var zoomViewer = $zoomContainer.data("zoomViewer");
            if (zoomViewer) {
                zoomViewer.resetZoom();
                $zoomContainer.removeClass("zoomed-in");
                $zoomOutBtn.addClass("d-none");
                $zoomInBtn.removeClass("d-none");
            }
        });
        if (!$window.data("zoomEventInitialized")) {
            $window.on("windowresize", function () {
                $(".zoom-container").each(function () {
                    var zoomViewer = $(this).data("zoomViewer");
                    if (zoomViewer) {
                        zoomViewer.resetZoom();
                        $(this).removeClass("zoomed-in");
                        $zoomOutBtn.addClass("d-none");
                        $zoomInBtn.removeClass("d-none");
                    }
                });
            });
            $window.data("zoomEventInitialized", true);
        }
    }

    $zoomSlider.on("init", function (_event, slick) {
        if (!isZoomDisabled) {
            $.each(slick.$slides, function (_i, el) {
                var $slide = $(el);
                var $zoomContainer = $slide.find(".zoom-container");
                var zoomData = $zoomContainer.data();
                var zoomViewer = new ImageViewer($zoomContainer[0], {
                    "snapView": false
                });
                zoomViewer.load(zoomData.src, zoomData.highResSrc);
                $zoomContainer.data("zoomViewer", zoomViewer);

                setTimeout(function () {
                    var $img = $zoomContainer.find(".iv-large-image");
                    $img.attr("srcset", zoomData.srcset).attr("sizes", zoomData.sizes);
                    if (_i > 0) {
                        $img.attr("loading", "lazy");
                    }
                }, 500);
            });

            $(document).on("dblclick", ".zoom-container", function () {
                $(this).toggleClass("zoomed-in");
                $zoomOutBtn.toggleClass("d-none");
                $zoomInBtn.toggleClass("d-none");
            });

            $(document).on("click", ".button-zoom-in", function () {
                $zoomSlider.slick("slickSetOption", "swipe", false);
                $(".slick-arrow").hide();
                $zoomOutBtn.toggleClass("d-none");
                $(this).toggleClass("d-none");
                var $currentSlide = $zoomSlider.find(".slick-current");
                var $currentImage = $currentSlide.find(".zoom-container");
                $currentImage.addClass("zoomed-in");
                var zoomViewer = $currentImage.data("zoomViewer");
                zoomViewer.zoom(200);
            });

            $(document).on("click", ".button-zoom-out", function () {
                $zoomSlider.slick("slickSetOption", "swipe", true);
                $(".slick-arrow").show();
                $zoomInBtn.toggleClass("d-none");
                $(this).toggleClass("d-none");
                var $currentSlide = $zoomSlider.find(".slick-current");
                var $currentImage = $currentSlide.find(".zoom-container");
                $currentImage.removeClass("zoomed-in");
                var zoomViewer = $currentImage.data("zoomViewer");
                zoomViewer.zoom(100);
            });
        }
        $zoomSlider.removeClass("not-initialized");
    });

    $zoomThumbSlider.on("init", function (_event) {
        $zoomThumbSlider.removeClass("not-initialized");
    });

    $zoomSlider.slick({
        infinite: true,
        initialSlide: startIndex
    });

    $zoomThumbSlider.slick({
        mobileFirst: true,
        focusOnSelect: true,
        slidesToShow: 3.5,
        infinite: true,
        arrows: false,
        dots: true,
        asNavFor: $zoomSlider,
        initialSlide: startIndex,
        responsive: [{
            breakpoint: commonFeature.getBreakpointMin("md") - 0.2,
            settings: {
                slidesToShow: 10
            }
        }]
    });

    $zoomThumbSlider.on("click", ".slick-slide:not(.slick-current)", function () {
        var $clickedSlide = $(this);
        if ($clickedSlide.hasClass("slick-current")) {
            return;
        }
        var goToSingleSlide = $clickedSlide.attr("data-slick-index");
        $zoomThumbSlider.slick("slickGoTo", parseInt(goToSingleSlide, 10));
    });

    $zoomSlider.on("afterChange", function (_event, _slick, currentSlide) {
        var $targetSlide = $zoomThumbSlider.find(".slick-slide[data-slick-index=\"" + currentSlide + "\"]");
        if ($targetSlide && !$targetSlide.hasClass("slick-current")) {
            $zoomThumbSlider.slick("slickGoTo", currentSlide);
        }
    });
}

var zoomModal = {
    init: init,
    initZoomModal: initZoomModal,
    initZoomCarousel: initZoomCarousel
};

module.exports = zoomModal;
